import { useContext } from 'react';
import { CurrentUserContext } from '../../contexts/CurrentUserContext';
import Card from '../Card/Card';

function Main({ onEditAvatar, onEditProfile, onAddPlace, onCardClick, onCardLike, onCardDelete, cards }) {


return (
        <main>
            <section className="profile">
                    <div className="profile__container-info">
                        <div className="profile__container-avatar">
                            {/* <img src={currentUser.avatar} className="profile__avatar" alt="Аватар профиля." /> */}
                            <button onClick={onEditAvatar} className="profile__avatar-edit-button"
                                aria-label="открыть форму редактирования аватара"></button>
                        </div>
                        <div className="profile__user">
                            <div className="profile__info">
                                <h1 className="profile__name">Имя</h1>
                                {/* {currentUser.name}</h1> */}
                                <p className="profile__caption">О пользователе</p>
                                {/* {currentUser.about}</p> */}
                            </div>
                            <button onClick={onEditProfile} type="button" className="profile__edit-button" aria-label="редактировать профиль">
                            </button>
                        </div>
                    </div>
                    <button onClick={onAddPlace} type="button" className="profile__add-button" aria-label="добавить фото"></button>
                </section>
                <section className="elements">
                    <ul className="elements__list">
                        {cards.map(card => {
                            return (
                                <Card
                                    key={card._id}
                                    card={card}
                                    onCardClick={onCardClick}
                                    onCardLike={onCardLike}
                                    onCardDelete={onCardDelete}
                                />)
                        })}
                    </ul>
                </section>
        </main>
    );
};

export default Main;
